// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application';

import AccordionHelperController from './accordion_helper_controller';
application.register('accordion-helper', AccordionHelperController);

import AdminReviewDeliveryController from './admin_review_delivery_controller';
application.register('admin-review-delivery', AdminReviewDeliveryController);

import AdvanceSelectController from './advance_select_controller';
application.register('advance-select', AdvanceSelectController);

import AgencyController from './agency_controller';
application.register('agency', AgencyController);

import AiAdvancedImageSelectController from './ai_advanced_image_select_controller';
application.register('ai-advanced-image-select', AiAdvancedImageSelectController);

import AiAspectRatioSliderController from './ai_aspect_ratio_slider_controller';
application.register('ai-aspect-ratio-slider', AiAspectRatioSliderController);

import AiAssistantController from './ai_assistant_controller';
application.register('ai-assistant', AiAssistantController);

import AiAudioController from './ai_audio_controller';
application.register('ai-audio', AiAudioController);

import AiAudioRecorderController from './ai_audio_recorder_controller';
application.register('ai-audio-recorder', AiAudioRecorderController);

import AiAutoGenerateController from './ai_auto_generate_controller';
application.register('ai-auto-generate', AiAutoGenerateController);

import AiBlockedQueryModalController from './ai_blocked_query_modal_controller';
application.register('ai-blocked-query-modal', AiBlockedQueryModalController);

import AiControlGenerateButtonController from './ai_control_generate_button_controller';
application.register('ai-control-generate-button', AiControlGenerateButtonController);

import AiGridController from './ai_grid_controller';
application.register('ai-grid', AiGridController);

import AiHintController from './ai_hint_controller';
application.register('ai-hint', AiHintController);

import AiHistoriesController from './ai_histories_controller';
application.register('ai-histories', AiHistoriesController);

import AiImageCountSubscriptionPopUpController from './ai_image_count_subscription_pop_up_controller';
application.register('ai-image-count-subscription-pop-up', AiImageCountSubscriptionPopUpController);

import AiImagePromptsController from './ai_image_prompts_controller';
application.register('ai-image-prompts', AiImagePromptsController);

import AiImageVariantController from './ai_image_variant_controller';
application.register('ai-image-variant', AiImageVariantController);

import AiManageShowTogglerController from './ai_manage_show_toggler_controller';
application.register('ai-manage-show-toggler', AiManageShowTogglerController);

import AiMixersController from './ai_mixers_controller';
application.register('ai-mixers', AiMixersController);

import AiRightPanelOptionsTogglerController from './ai_right_panel_options_toggler_controller';
application.register('ai-right-panel-options-toggler', AiRightPanelOptionsTogglerController);

import AiSavedPromptsController from './ai_saved_prompts_controller';
application.register('ai-saved-prompts', AiSavedPromptsController);

import AiShowcaseIndexController from './ai_showcase_index_controller';
application.register('ai-showcase-index', AiShowcaseIndexController);

import AiStepContextController from './ai_step_context_controller';
application.register('ai-step-context', AiStepContextController);

import AnimateOutSetterController from './animate_out_setter_controller';
application.register('animate-out-setter', AnimateOutSetterController);

import AnnouncementFormAiModalController from './announcement_form_ai_modal_controller';
application.register('announcement-form-ai-modal', AnnouncementFormAiModalController);

import AssistantPersonaController from './assistant_persona_controller';
application.register('assistant-persona', AssistantPersonaController);

import AudioPlayerController from './audio_player_controller';
application.register('audio-player', AudioPlayerController);

import AutoCycleImagesController from './auto_cycle_images_controller';
application.register('auto-cycle-images', AutoCycleImagesController);

import AutoCycleTextsController from './auto_cycle_texts_controller';
application.register('auto-cycle-texts', AutoCycleTextsController);

import AutoDeclineRadioDisableController from './auto_decline_radio_disable_controller';
application.register('auto-decline-radio-disable', AutoDeclineRadioDisableController);

import AutoGrowTextareaController from './auto_grow_textarea_controller';
application.register('auto-grow-textarea', AutoGrowTextareaController);

import AutocompleteSearchController from './autocomplete_search_controller';
application.register('autocomplete-search', AutocompleteSearchController);

import AutomaticAddClassOnBreakpointController from './automatic_add_class_on_breakpoint_controller';
application.register('automatic-add-class-on-breakpoint', AutomaticAddClassOnBreakpointController);

import AutompleteSearchResultsController from './automplete_search_results_controller';
application.register('automplete-search-results', AutompleteSearchResultsController);

import AutoscrollController from './autoscroll_controller';
application.register('autoscroll', AutoscrollController);

import BrandFetchController from './brand_fetch_controller';
application.register('brand-fetch', BrandFetchController);

import BugsnagPerformanceController from './bugsnag_performance_controller';
application.register('bugsnag-performance', BugsnagPerformanceController);

import BulkActionsController from './bulk_actions_controller';
application.register('bulk-actions', BulkActionsController);

import CancelOrderController from './cancel_order_controller';
application.register('cancel-order', CancelOrderController);

import ChallengeVisibilityController from './challenge_visibility_controller';
application.register('challenge-visibility', ChallengeVisibilityController);

import ChangeCreatePromptController from './change_create_prompt_controller';
application.register('change-create-prompt', ChangeCreatePromptController);

import ChangePasswordFormController from './change_password_form_controller';
application.register('change-password-form', ChangePasswordFormController);

import ChangePhoneNumberFormController from './change_phone_number_form_controller';
application.register('change-phone-number-form', ChangePhoneNumberFormController);

import ChangeRequestFieldsController from './change_request_fields_controller';
application.register('change-request-fields', ChangeRequestFieldsController);

import ChangeRequestsTurboController from './change_requests_turbo_controller';
application.register('change-requests-turbo', ChangeRequestsTurboController);

import CharacterCounterController from './character_counter_controller';
application.register('character-counter', CharacterCounterController);

import CharacterWatcherController from './character_watcher_controller';
application.register('character-watcher', CharacterWatcherController);

import ChatFormController from './chat_form_controller';
application.register('chat-form', ChatFormController);

import ChatScrollController from './chat_scroll_controller';
application.register('chat-scroll', ChatScrollController);

import ClassAdderController from './class_adder_controller';
application.register('class-adder', ClassAdderController);

import ClassAnimationTogglerController from './class_animation_toggler_controller';
application.register('class-animation-toggler', ClassAnimationTogglerController);

import ClassTogglerController from './class_toggler_controller';
application.register('class-toggler', ClassTogglerController);

import ClickController from './click_controller';
application.register('click', ClickController);

import CommunityShowcaseModalController from './community_showcase_modal_controller';
application.register('community-showcase-modal', CommunityShowcaseModalController);

import CompensationFilterController from './compensation_filter_controller';
application.register('compensation-filter', CompensationFilterController);

import CompensationsController from './compensations_controller';
application.register('compensations', CompensationsController);

import ComposerController from './composer_controller';
application.register('composer', ComposerController);

import ConnectionFetchingController from './connection_fetching_controller';
application.register('connection-fetching', ConnectionFetchingController);

import ContractFormValidateController from './contract_form_validate_controller';
application.register('contract-form-validate', ContractFormValidateController);

import ConversationController from './conversation_controller';
application.register('conversation', ConversationController);

import CopyToClipboardController from './copy_to_clipboard_controller';
application.register('copy-to-clipboard', CopyToClipboardController);

import CoverImageStepController from './cover_image_step_controller';
application.register('cover-image-step', CoverImageStepController);

import CreateAiVideoController from './create_ai_video_controller';
application.register('create-ai-video', CreateAiVideoController);

import CreateSelectController from './create_select_controller';
application.register('create-select', CreateSelectController);

import CreatorMembershipController from './creator_membership_controller';
application.register('creator-membership', CreatorMembershipController);

import CreatorRequestsController from './creator_requests_controller';
application.register('creator-requests', CreatorRequestsController);

import DatatableColumnsController from './datatable_columns_controller';
application.register('datatable-columns', DatatableColumnsController);

import DatatableExportController from './datatable_export_controller';
application.register('datatable-export', DatatableExportController);

import DetectAiPromptLimitExceededController from './detect_ai_prompt_limit_exceeded_controller';
application.register('detect-ai-prompt-limit-exceeded', DetectAiPromptLimitExceededController);

import DismissOffcanvasOnTurboRenderController from './dismiss_offcanvas_on_turbo_render_controller';
application.register('dismiss-offcanvas-on-turbo-render', DismissOffcanvasOnTurboRenderController);

import DocExportController from './doc_export_controller';
application.register('doc-export', DocExportController);

import DownloadFileController from './download_file_controller';
application.register('download-file', DownloadFileController);

import DreamscaleController from './dreamscale_controller';
application.register('dreamscale', DreamscaleController);

import DropdownController from './dropdown_controller';
application.register('dropdown', DropdownController);

import DropzoneController from './dropzone_controller';
application.register('dropzone', DropzoneController);

import ElClickerController from './el_clicker_controller';
application.register('el-clicker', ElClickerController);

import EnableButtonWhenCheckboxCheckedController from './enable_button_when_checkbox_checked_controller';
application.register(
  'enable-button-when-checkbox-checked',
  EnableButtonWhenCheckboxCheckedController
);

import ExportCopyToClipboardController from './export_copy_to_clipboard_controller';
application.register('export-copy-to-clipboard', ExportCopyToClipboardController);

import FlatpickrController from './flatpickr_controller';
application.register('flatpickr', FlatpickrController);

import FlowDashboardController from './flow_dashboard_controller';
application.register('flow-dashboard', FlowDashboardController);

import FlowStatusController from './flow_status_controller';
application.register('flow-status', FlowStatusController);

import FocusController from './focus_controller';
application.register('focus', FocusController);

import ForgotPasswordFormController from './forgot_password_form_controller';
application.register('forgot-password-form', ForgotPasswordFormController);

import ForgotPasswordVerificationFormController from './forgot_password_verification_form_controller';
application.register('forgot-password-verification-form', ForgotPasswordVerificationFormController);

import FormAutoSubmitOnChangeController from './form_auto_submit_on_change_controller';
application.register('form-auto-submit-on-change', FormAutoSubmitOnChangeController);

import FormValidateController from './form_validate_controller';
application.register('form-validate', FormValidateController);

import FormsHelperController from './forms_helper_controller';
application.register('forms-helper', FormsHelperController);

import GendersController from './genders_controller';
application.register('genders', GendersController);

import GetStartedController from './get_started_controller';
application.register('get-started', GetStartedController);

import GlightboxController from './glightbox_controller';
application.register('glightbox', GlightboxController);

import GradientAnimationController from './gradient_animation_controller';
application.register('gradient-animation', GradientAnimationController);

import HighchartsController from './highcharts_controller';
application.register('highcharts', HighchartsController);

import HubspotChatController from './hubspot_chat_controller';
application.register('hubspot-chat', HubspotChatController);

import ImageUploadController from './image_upload_controller';
application.register('image-upload', ImageUploadController);

import IntroTutorialController from './intro_tutorial_controller';
application.register('intro-tutorial', IntroTutorialController);

import LabelAnimatorController from './label_animator_controller';
application.register('label-animator', LabelAnimatorController);

import LegalDisclaimerInitController from './legal_disclaimer_init_controller';
application.register('legal-disclaimer-init', LegalDisclaimerInitController);

import ListingCategoryChangeController from './listing_category_change_controller';
application.register('listing-category-change', ListingCategoryChangeController);

import ListingController from './listing_controller';
application.register('listing', ListingController);

import ListingPrefillChangeController from './listing_prefill_change_controller';
application.register('listing-prefill-change', ListingPrefillChangeController);

import ListingTileController from './listing_tile_controller';
application.register('listing-tile', ListingTileController);

import LocationFilterController from './location_filter_controller';
application.register('location-filter', LocationFilterController);

import LocationReloaderController from './location_reloader_controller';
application.register('location-reloader', LocationReloaderController);

import LockedAiAssistantMembershipModalController from './locked_ai_assistant_membership_modal_controller';
application.register(
  'locked-ai-assistant-membership-modal',
  LockedAiAssistantMembershipModalController
);

import LockedAiModelMembershipModalController from './locked_ai_model_membership_modal_controller';
application.register('locked-ai-model-membership-modal', LockedAiModelMembershipModalController);

import LogInFormController from './log_in_form_controller';
application.register('log-in-form', LogInFormController);

import LottieController from './lottie_controller';
application.register('lottie', LottieController);

import MessageActionsController from './message_actions_controller';
application.register('message-actions', MessageActionsController);

import MessageController from './message_controller';
application.register('message', MessageController);

import MissingImageHandlerController from './missing_image_handler_controller';
application.register('missing-image-handler', MissingImageHandlerController);

import MobileViewPortHandlerController from './mobile_view_port_handler_controller';
application.register('mobile-view-port-handler', MobileViewPortHandlerController);

import ModalController from './modal_controller';
application.register('modal', ModalController);

import NestedFormController from './nested_form_controller';
application.register('nested-form', NestedFormController);

import NextDisablerController from './next_disabler_controller';
application.register('next-disabler', NextDisablerController);

import OffsetParallaxController from './offset_parallax_controller';
application.register('offset-parallax', OffsetParallaxController);

import OpportunityAttachmentsController from './opportunity_attachments_controller';
application.register('opportunity-attachments', OpportunityAttachmentsController);

import OpportunityPrefillChangeController from './opportunity_prefill_change_controller';
application.register('opportunity-prefill-change', OpportunityPrefillChangeController);

import OrderAddendumController from './order_addendum_controller';
application.register('order-addendum', OrderAddendumController);

import OrderSummaryChangeController from './order_summary_change_controller';
application.register('order-summary-change', OrderSummaryChangeController);

import OtherFieldController from './other_field_controller';
application.register('other-field', OtherFieldController);

import PageNotificationController from './page_notification_controller';
application.register('page-notification', PageNotificationController);

import PasswordComplexityController from './password_complexity_controller';
application.register('password-complexity', PasswordComplexityController);

import PauseVideoOutsideViewportController from './pause_video_outside_viewport_controller';
application.register('pause-video-outside-viewport', PauseVideoOutsideViewportController);

import PaypalModalController from './paypal_modal_controller';
application.register('paypal-modal', PaypalModalController);

import PhoneVerificationModalController from './phone_verification_modal_controller';
application.register('phone-verification-modal', PhoneVerificationModalController);

import PitchReviewController from './pitch_review_controller';
application.register('pitch-review', PitchReviewController);

import PitchDeclineReasonController from './pitch_decline_reason_controller';
application.register('pitch-decline-reason', PitchDeclineReasonController);

import PitchTableRowController from './pitch_table_row_controller';
application.register('pitch-table-row', PitchTableRowController);

import PitchVideoController from './pitch_video_controller';
application.register('pitch-video', PitchVideoController);

import PlanUpdateController from './plan_update_controller';
application.register('plan-update', PlanUpdateController);

import ProgressBarController from './progress_bar_controller';
application.register('progress-bar', ProgressBarController);

import RangeCadenceController from './range_cadence_controller';
application.register('range-cadence', RangeCadenceController);

import RangeSliderController from './range_slider_controller';
application.register('range-slider', RangeSliderController);

import RedirectOnConnectController from './redirect_on_connect_controller';
application.register('redirect-on-connect', RedirectOnConnectController);

import RemoteModalController from './remote_modal_controller';
application.register('remote-modal', RemoteModalController);

import RemoteOffcanvasController from './remote_offcanvas_controller';
application.register('remote-offcanvas', RemoteOffcanvasController);

import RemoveConditionallyController from './remove_conditionally_controller';
application.register('remove-conditionally', RemoveConditionallyController);

import ReplaceHistoryLocationController from './replace_history_location_controller';
application.register('replace-history-location', ReplaceHistoryLocationController);

import ResetInputmaskController from './reset_inputmask_controller';
application.register('reset-inputmask', ResetInputmaskController);

import ResetTomselectController from './reset_tomselect_controller';
application.register('reset-tomselect', ResetTomselectController);

import RichTextToolbarController from './rich_text_toolbar_controller';
application.register('rich-text-toolbar', RichTextToolbarController);

import SearchController from './search_controller';
application.register('search', SearchController);

import ShowHelpDocumentController from './show_help_document_controller';
application.register('show-help-document', ShowHelpDocumentController);

import ShowhideController from './showhide_controller';
application.register('showhide', ShowhideController);

import SimpleParallaxController from './simple_parallax_controller';
application.register('simple-parallax', SimpleParallaxController);

import SingleRangeSliderController from './single_range_slider_controller';
application.register('single-range-slider', SingleRangeSliderController);

import SpokeLanguageController from './spoke_language_controller';
application.register('spoke-language', SpokeLanguageController);

import StickItController from './stick_it_controller';
application.register('stick-it', StickItController);

import StripePaymentMethodController from './stripe_payment_method_controller';
application.register('stripe-payment-method', StripePaymentMethodController);

import SvelteComponentController from './svelte_component_controller';
application.register('svelte-component', SvelteComponentController);

import SwiperInitializerController from './swiper_initializer_controller';
application.register('swiper-initializer', SwiperInitializerController);

import TabNavigationController from './tab_navigation_controller';
application.register('tab-navigation', TabNavigationController);

import TabSetterController from './tab_setter_controller';
application.register('tab-setter', TabSetterController);

import TiktokOauthModalController from './tiktok_oauth_modal_controller';
application.register('tiktok-oauth-modal', TiktokOauthModalController);

import ToastController from './toast_controller';
application.register('toast', ToastController);

import TooltipInitController from './tooltip_init_controller';
application.register('tooltip-init', TooltipInitController);

import TurboFrameLoaderController from './turbo_frame_loader_controller';
application.register('turbo-frame-loader', TurboFrameLoaderController);

import TurboUploaderController from './turbo_uploader_controller';
application.register('turbo-uploader', TurboUploaderController);

import UnreadMessagesCountController from './unread_messages_count_controller';
application.register('unread-messages-count', UnreadMessagesCountController);


import UserTypeController from './user_type_controller';
application.register('user-type', UserTypeController);

import VerifyPhoneNumberFormController from './verify_phone_number_form_controller';
application.register('verify-phone-number-form', VerifyPhoneNumberFormController);

import UpdateButtonTextController from './update_button_text_controller';
application.register('update-button-text', UpdateButtonTextController);

import VerticalsController from './verticals_controller';
application.register('verticals', VerticalsController);

import VideoRecordController from './video_record_controller';
application.register('video-record', VideoRecordController);

import ViewingAsController from './viewing_as_controller';
application.register('viewing-as', ViewingAsController);

import ViewportClassTogglerController from './viewport_class_toggler_controller';
application.register('viewport-class-toggler', ViewportClassTogglerController);

import WizardController from './wizard_controller';
application.register('wizard', WizardController);
